import { useMutation, useQueryClient } from 'react-query';
import { PostPayload, timefitBackend } from '../../../Shared/Services/TimefitBackend';
import { keys } from '../../../Shared/Services/Query/Keys.ts';

export function useUpdatePost(key: string) {
  const queryClient = useQueryClient();

  const mutation = (payload: Partial<PostPayload>) => {
    return timefitBackend.updatePost(key, payload);
  };

  return useMutation(mutation, {
    onSuccess: () => {
      void queryClient.invalidateQueries(keys.posts.list());
      void queryClient.invalidateQueries(keys.posts.one(key));
    },
  });
}
